import { Component, Input } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'
import { MediaRootPermissionPermissionFields } from 'media/constants'
import { TranslateService } from '@ngx-translate/core'
import { MediaRootDetail, MediaRootPermission } from 'elements-sdk'

@Component({
  templateUrl: './mediaPermissionModal.component.pug',
})
export class MediaPermissionModalComponent {
  @Input() permission: MediaRootPermission
  @Input() root?: MediaRootDetail

  membersPlural = `{count, plural,
    =0{Empty}
    one{One member}
    other{{count} members}
  }`

  constructor (
    private modalInstance: NgbActiveModal,
    private translate: TranslateService,
  ) { }

  save () {
    this.modalInstance.close(this.permission)
  }

  cancel () {
    this.modalInstance.dismiss()
  }

  isValid () {
    return MediaRootPermissionPermissionFields.some(k => this.permission[k])
  }
}
